/**
 * Notify Me Modal
 * Opens when user clicks "Notify me when available" on sold-out products.
 * Submits to Shopify contact form. Integrates with .nm-portal / .restock-alerts-notify-button apps.
 */
(function () {
  const modalId = "NotifyMeModal";

  function openNotifyMeModal(detail) {
    const nmButton = document.querySelector(".nm-portal button, .restock-alerts-notify-button");
    if (nmButton) {
      nmButton.click();
      return;
    }

    const modal = document.getElementById(modalId);
    if (!modal) return;

    const bodyInput = modal.querySelector("[data-notify-me-body]");
    const emailInput = modal.querySelector("[data-notify-me-email]");
    const messageEl = modal.querySelector("[data-notify-me-message]");

    if (bodyInput) {
      const parts = [
        "Back in stock request",
        `Product: ${detail.productTitle || ""}`,
        `Variant: ${detail.variantTitle || ""} (ID: ${detail.variantId || ""})`,
        `URL: ${window.shopUrl || ""}${detail.productUrl || window.location.pathname}`,
      ];
      bodyInput.value = parts.filter(Boolean).join("\n");
    }
    if (emailInput) {
      emailInput.value = "";
    }
    if (messageEl) {
      messageEl.hidden = true;
      messageEl.textContent = "";
      messageEl.classList.remove("notify-me-form__message--success", "notify-me-form__message--error");
    }

    modal.show(document.activeElement);
    setTimeout(() => emailInput?.focus(), 100);
  }

  function init() {
    const modal = document.getElementById(modalId);
    const form = modal?.querySelector("[data-notify-me-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const submitBtn = modal.querySelector("[data-notify-me-submit]");
        const messageEl = modal.querySelector("[data-notify-me-message]");
        const emailInput = modal.querySelector("[data-notify-me-email]");

        if (!emailInput?.value?.trim()) return;

        submitBtn.disabled = true;
        messageEl.hidden = true;

        const formData = new FormData(form);
        const body = new URLSearchParams(formData).toString();

        fetch("/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest",
          },
          body,
        })
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const successMsg = doc.querySelector(".form-status-list.form__message");
            const errorMsg = doc.querySelector(".form-status-list.caption-large");

            if (successMsg) {
              messageEl.textContent =
                window.notifyMeStrings?.success || "Thanks! We'll email you when this item is back in stock.";
              messageEl.classList.add("notify-me-form__message--success");
              messageEl.classList.remove("notify-me-form__message--error");
              messageEl.hidden = false;
              form.reset();
              setTimeout(() => modal.hide(), 2000);
            } else if (errorMsg) {
              messageEl.textContent = errorMsg.textContent || "Something went wrong. Please try again.";
              messageEl.classList.add("notify-me-form__message--error");
              messageEl.classList.remove("notify-me-form__message--success");
              messageEl.hidden = false;
            }
          })
          .catch(() => {
            messageEl.textContent = "Something went wrong. Please try again.";
            messageEl.classList.add("notify-me-form__message--error");
            messageEl.classList.remove("notify-me-form__message--success");
            messageEl.hidden = false;
          })
          .finally(() => {
            submitBtn.disabled = false;
          });
      });
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-notify-me-button]");
      if (!btn) return;
      e.preventDefault();
      openNotifyMeModal({
        variantId: btn.dataset.variantId,
        productUrl: btn.dataset.productUrl,
        productTitle: btn.dataset.productTitle,
        variantTitle: btn.dataset.variantTitle,
      });
    });

    window.addEventListener("notify-me", (e) => {
      openNotifyMeModal(e.detail || {});
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
